export default path => {
	switch (path) {
		case '/': {
			return 'index';
		}
		case '/nyheter/': {
			return 'blog';
		}
		case '/projekt/': {
			return 'projects';
		}
		case '/om-oss/': {
			return 'about';
		}
		default: {
			return 'page';
		}
	}
};



// WEBPACK FOOTER //
// utils/component.js